__turbopack_context__.v({
  "action": "InscriptionBelowImage-module__u527SW__action",
  "alertText": "InscriptionBelowImage-module__u527SW__alertText",
  "alertsButton": "InscriptionBelowImage-module__u527SW__alertsButton",
  "alertsRow": "InscriptionBelowImage-module__u527SW__alertsRow",
  "belowImage": "InscriptionBelowImage-module__u527SW__belowImage",
  "calendarIcon": "InscriptionBelowImage-module__u527SW__calendarIcon",
  "emailInput": "InscriptionBelowImage-module__u527SW__emailInput",
  "emailInputText": "InscriptionBelowImage-module__u527SW__emailInputText",
  "footer": "InscriptionBelowImage-module__u527SW__footer",
  "footerMobile": "InscriptionBelowImage-module__u527SW__footerMobile",
  "footerRow": "InscriptionBelowImage-module__u527SW__footerRow",
  "header": "InscriptionBelowImage-module__u527SW__header",
  "headerLeft": "InscriptionBelowImage-module__u527SW__headerLeft",
  "headerTitle": "InscriptionBelowImage-module__u527SW__headerTitle",
  "icon": "InscriptionBelowImage-module__u527SW__icon",
  "imgContainer": "InscriptionBelowImage-module__u527SW__imgContainer",
  "mintAlertButton": "InscriptionBelowImage-module__u527SW__mintAlertButton",
  "mintAlertInput": "InscriptionBelowImage-module__u527SW__mintAlertInput",
  "mintImage": "InscriptionBelowImage-module__u527SW__mintImage",
  "root": "InscriptionBelowImage-module__u527SW__root",
  "socials": "InscriptionBelowImage-module__u527SW__socials",
  "twitterBlue": "InscriptionBelowImage-module__u527SW__twitterBlue",
  "twitterRow": "InscriptionBelowImage-module__u527SW__twitterRow",
  "twitterText": "InscriptionBelowImage-module__u527SW__twitterText",
  "waitlist": "InscriptionBelowImage-module__u527SW__waitlist",
});
